import { fetchConToken } from '../utils/fetch.ts';

/**
 * Obtener lista de comprobantes faltantes (solo admin)
 * GET /admin/comprobantes/missing
 * 
 * @param {Object} filters - Filtros opcionales
 * @param {string} filters.startDate - Fecha inicio (YYYY-MM-DD)
 * @param {string} filters.endDate - Fecha fin (YYYY-MM-DD)
 * @param {string} filters.usuario - Filtrar por usuario (nombre o RUT)
 * @param {string} filters.gira - Filtrar por gira (ID)
 * @returns {Promise<Object>} { error, data, total_faltantes }
 */
export const getMissingComprobantes = async (filters = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (filters.startDate) queryParams.append('startDate', filters.startDate);
    if (filters.endDate) queryParams.append('endDate', filters.endDate);
    if (filters.usuario) queryParams.append('usuario', filters.usuario);
    if (filters.gira) queryParams.append('gira', filters.gira);

    const queryString = queryParams.toString();
    const url = `admin/comprobantes/missing${queryString ? '?' + queryString : ''}`;

    const resp = await fetchConToken(url, {}, "GET");
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error fetching missing comprobantes:', error);
    return { error: true, msg: 'Error al obtener comprobantes faltantes' };
  }
};

/**
 * Regenerar comprobantes seleccionados (solo admin)
 * POST /admin/comprobantes/regenerate
 * 
 * @param {Array<number>} webpay_ids - IDs de transacciones GetNet a regenerar
 * @returns {Promise<Object>} { error, msg, resultados, total_regenerados, total_errores }
 */
export const regenerateComprobantes = async (webpay_ids) => {
  try {
    if (!Array.isArray(webpay_ids) || webpay_ids.length === 0) {
      return { error: true, msg: 'webpay_ids debe ser un array no vacío' };
    }

    if (webpay_ids.length > 50) {
      return { error: true, msg: 'Máximo 50 comprobantes por regeneración' };
    }

    const resp = await fetchConToken('admin/comprobantes/regenerate', {
      webpay_ids
    }, "POST");
    
    const body = await resp.json();
    return body;
  } catch (error) {
    console.error('Error regenerating comprobantes:', error);
    return { error: true, msg: 'Error al regenerar comprobantes' };
  }
};
